import * as React from 'react';

import { enumUnit, Unit } from '@rematter/frontend-lib-api-client';
import { useWeightConversion } from '@rematter/modules/trade/hooks/useWeightConversion';
import { enumLoadWeightType } from '@rematter/modules/trade/types/load';

import { QuantityOwedFieldCellProps } from '../types';

import { WeightFieldCell } from '~/shared/components/line-items';

export const QuantityOwedFieldCell: React.FC<QuantityOwedFieldCellProps> = ({
  lineItem,
  weightUnit = 'price',
  disabled,
  facilityDefaultUnit = enumUnit.Pounds,
}) => {
  const { convertToDisplayUnit, massUnitAbbreviation } = useWeightConversion({
    weightUnit,
    facilityDefaultUnit,
    pricingUnit: lineItem.pricingUnit as Unit,
  });

  return (
    <WeightFieldCell
      value={convertToDisplayUnit(
        lineItem.weights?.[enumLoadWeightType.QuantityOwed],
      )}
      disabled={disabled}
      suffix={massUnitAbbreviation}
      className="@QuantityOwedFieldCell"
    />
  );
};
